module.exports = {
      id: "speakeraudio-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#speakeraudio",
      toString: function () {
        return this.url;
      }
    }